const CONFIG = {
  stakingContract: "0x45e72473Af2898Bbf9fc4EE5D84f139c03fCCFd1", //deploy on remix on 28dec with changes of timer etc.
  tokenAddress: "0x10008002e4465835278bc0f85afba12aca2b3997", //sthis is VERSX TOKEN
  tokenDecimals: 10,
  tokenSymbol: "VERSX",
};

export default CONFIG;
